function HideColumnButton({ column, hideColumn }) {
  const handleClick = () => {
    hideColumn(column)
  }

  return (
    <button type="button" className="inline-flex items-center text-base text-secondary-hover" onClick={handleClick}>
      <svg viewBox="0 0 11 11" fill="none" className="flex-shrink-0 mr-2 w-3">
        <circle cx="5.5" cy="5.5" r="5.5" fill="currentColor" />
        <path
          d="M5.813 6h2.083C7.953 6 8 5.925 8 5.833v-.666C8 5.075 7.953 5 7.896 5H3.104C3.047 5 3 5.075 3 5.167v.666c0 .092.047.167.104.167h2.708Z"
          fill="#fff"
        />
      </svg>

      <span>Hide</span>
    </button>
  )
}

export default HideColumnButton
